import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import { dismissibleChild } from "MODULES/shared/decorators";
import { Icon } from "MODULES/shared/components";
import ConfirmAction from "MODULES/shared/components/ConfirmAction/ConfirmAction";
import Create from "MODULES/RepairOrders/components/ConvertToRo/Create";
import { REPAIR, REPAIR_CART_ITEMS } from "MODULES/users/constants";
import Authorized from "MODULES/shared/components/Authorized";
import { isArray } from "lodash";
import { destroy, clearCart, subscribe } from "./actions";
import Item from "./Item";

class Cart extends React.Component {
  state = {
    convertModalOpen: false,
    clearCartModalOpen: false
  };

  componentDidMount() {
    this.props.subscribeToRepairCart();
  }

  openConvertModal = e => {
    this.setState({ convertModalOpen: true });
    this.props.toggle(e);
  };
  closeConvertModal = () => this.setState({ convertModalOpen: false });

  openClearCartModal = () => this.setState({ clearCartModalOpen: true });
  closeClearCartModal = () => this.setState({ clearCartModalOpen: false });

  handleClearCart = () => {
    this.props.removeAll();
    this.closeClearCartModal();
  };

  renderItem = (item, i) => {
    const { pushHistory, removeItem } = this.props;

    return (
      <Item
        {...item}
        key={`cart-item-${i}`}
        destroy={removeItem}
        pushHistory={pushHistory}
      />
    );
  };

  renderClearCart = () => (
    <li className="cart-item text-center" style={{ cursor: "pointer" }}>
      <button
        className="btn btn-danger center-block empty-cart"
        onClick={this.openClearCartModal}
      >
        <span>
          Empty Cart
          <Icon name="shopping-cart" />
        </span>
      </button>

      <ConfirmAction
        onConfirm={this.handleClearCart}
        close={this.closeClearCartModal}
        open={this.state.clearCartModalOpen}
      >
        <strong>Heads up!</strong> Are you sure you want to empty your cart?
      </ConfirmAction>
    </li>
  );

  render() {
    const { close, visible, toggle, contentRef, repairCartItems } = this.props;

    if (!repairCartItems) return null;

    const totalCount = repairCartItems.length;

    const classes = classNames("navbar-dropdown-icon ro-cart", {
      open: visible
    });

    return (
      <Authorized roles={[REPAIR]}>
        <li className={classes} ref={contentRef} id="repairs-cart">
          <a
            className="dropdown-toggle"
            role="button"
            onClick={toggle}
            aria-expanded="false"
          >
            <i className="fa fa-fw fa-lg fa-shopping-basket" />
            <span className="hidden-md hidden-lg">&nbsp;Repair Cart</span>
            <span className="badge">{totalCount}</span>
          </a>
          <ul className="dropdown-menu" role="menu">
            <li className="text-center">
              <div className="row row-col-gutters-half">
                <div className="col-xs-6">
                  <span onClick={close}>
                    <Link to="/repair-orders/reserved">
                      <span type="button" className="btn btn-default btn-block">
                        Reserve List
                      </span>
                    </Link>
                  </span>
                </div>
                <div className="col-xs-6">
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    onClick={this.openConvertModal}
                    disabled={totalCount === 0}
                  >
                    Convert to RO
                  </button>
                </div>
              </div>
              <Create
                open={this.state.convertModalOpen}
                close={this.closeConvertModal}
                lineItems={repairCartItems}
              />
            </li>
            {repairCartItems.map(this.renderItem)}
            {repairCartItems.length > 0 && this.renderClearCart()}
          </ul>
        </li>
      </Authorized>
    );
  }
}

Cart.propTypes = {
  close: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  contentRef: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
  removeAll: PropTypes.func.isRequired,
  pushHistory: PropTypes.func.isRequired,
  loadCart: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  repairCartItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  subscribeToRepairCart: PropTypes.func.isRequired
};

export default connect(
  state => {
    const repairCartItems = state.session.get(REPAIR_CART_ITEMS).toJS();
    return {
      repairCartItems: isArray(repairCartItems) ? repairCartItems : []
    };
  },
  dispatch => ({
    removeItem: id => dispatch(destroy(id)),
    removeAll: () => dispatch(clearCart()),
    pushHistory: id => dispatch(push(`/inventories/${id}`)),
    subscribeToRepairCart: () => dispatch(subscribe())
  })
)(dismissibleChild(Cart));



// WEBPACK FOOTER //
// ./app/Nav/RepairOrdersCart/Cart.jsx